export type CredentialSubject = Object
